import React from 'react'
import CountryTooltip from './CountryTooltip'
import ProjectTooltip from './ProjectTooltip'
import CapacityTooltip from './CapacityTooltip'
import './styles.scss'
export default function Tooltip(props) {
  let tt = null;

  const xOffset = props.x > props.width / 2 ? -105 : 5;
  const windowScrollY = props.lockedTooltip && props.mapPositioned ? 0 : window.scrollY;
  const overHalfHeight = props.y > windowScrollY + props.height / 2;
  let yOffset = overHalfHeight ? -75 : -10;
  if (props.type === 'project') {
    yOffset = overHalfHeight ? -95 : -50;
  }
  const transform = `translate(${xOffset}%, ${yOffset}%)`

  const style = {
    left: props.x,
    top: props.y,
    ...props.wrapperStyle,
  };
  if (style.transform) {
    style.transform = style.transform + transform
  } else {
    style.transform = transform
  }

  if (props.type === 'country') {
    tt = <CountryTooltip {...props} />
  } else if (props.type === 'project') {
    tt = <ProjectTooltip {...props} xOffset={xOffset} yOffset={yOffset} />
  } else if (props.type === 'capacity') {
    tt = <CapacityTooltip {...props} />
  }
  return <div className='tooltipWrapper' style={style}>{tt}</div>
}
